import type { WebshopCalculatePriceButton } from "./types/types";

export const createWebshopCalculatePriceButton =
  (): WebshopCalculatePriceButton => {
    const event: WebshopCalculatePriceButton = {
      event: "Webshop Calculate Price Button",
    };
    return event;
  };
